import React from "react";
import ClipTitle from "./ClipTitle";

export default function PlayList(props) {
    let batterId = null;
    let pitcherId = null;
    let inning = null;
    let batInningTurn = null;

    //미리 playList를 한번 반복문을 돌려서 만약 투수, 타자. 이닝, 배팅 순서 중 하나라도 다르면 각 값을 새로 변수에 넣어주고 titleYn에 "Y"를 저장
    //타이틀을 출력 여부를 저장
    props.playList.forEach(function (item) {
        if (
            batterId === null ||
            item.batterId !== batterId ||
            pitcherId === null ||
            item.pitcherId !== pitcherId ||
            inning === null ||
            item.inning !== inning ||
            batInningTurn === null ||
            item.batInningTurn !== batInningTurn
        ) {
            batterId = item.batterId;
            pitcherId = item.pitcherId;
            inning = item.inning;
            batInningTurn = item.batInningTurn;

            item.titleYn = "Y";
        }

        //경기유형 추가
        if(item.gameType == 4201){
            item.gameTypeName = "KBO";
        } else if(item.gameType == 4206){
            if(props.useLang == "en"){
                item.gameTypeName = "Futures";
            } else {
                item.gameTypeName = "퓨쳐스";
            }
        } else if(item.gameType == 4212){
            if(props.useLang == "en"){
                item.gameTypeName = "R.squard";
            } else {
                item.gameTypeName = "육성군";
            }
        } else if(item.gameType == 4202){
            if(props.useLang == "en"){
                item.gameTypeName = "PS";
            } else {
                item.gameTypeName = "포스트시즌";
            }
        } else if(item.gameType == 4203){
            if(props.useLang == "en"){
                item.gameTypeName = "PS";
            } else {
                item.gameTypeName = "포스트시즌";
            }
        } else if(item.gameType == 4204){
            if(props.useLang == "en"){
                item.gameTypeName = "PS";
            } else {
                item.gameTypeName = "포스트시즌";
            }
        } else if(item.gameType == 4205){
            if(props.useLang == "en"){
                item.gameTypeName = "PS";
            } else {
                item.gameTypeName = "포스트시즌";
            }
        } else if(item.gameType == 4208){
            if(props.useLang == "en"){
                item.gameTypeName = "M.scrim";
            } else {
                item.gameTypeName = "1군연습";
            }
        } else if(item.gameType == 4213){
            if(props.useLang == "en"){
                item.gameTypeName = "F.scrim";
            } else {
                item.gameTypeName = "2군연습";
            }
        } else if(item.gameType == 4207){
            if(props.useLang == "en"){
                item.gameTypeName = "Exhib.";
            } else {
                item.gameTypeName = "시범";
            }
        } else if(item.gameType == 4214){
            if(props.useLang == "en"){
                item.gameTypeName = "Edu.";
            } else {
                item.gameTypeName = "교육";
            }
        }
    });

    if (props.playList.length > 0) {
        return (
            <React.Fragment>
                {props.playList.map((playInfo) => (
                    <div
                        key={
                            playInfo.gameInfoId +
                            playInfo.inning +
                            playInfo.inningTb +
                            playInfo.batInningTurn +
                            playInfo.batPitchSeq
                        }
                        onClick={props.selectClipEventHandler}
                        className="clip_list"
                        name="videoClips"
                        rel={
                            playInfo.gameInfoId +
                            playInfo.inning +
                            playInfo.inningTb +
                            playInfo.batInningTurn +
                            playInfo.batPitchSeq
                        }
                        // style={playInfo.pitchTime - props.videoInfos.taggingGapTime < 0 ? {pointerEvents:"none"} : {}}
                    >
                        <table id="clipTitleTable" style={{ width: "100%" }}>
                            <tbody>
                                {/* 만약 던진 공이 해당 타석의 첫번째 공이라면 타이틀 출력 */}
                                {playInfo.batPitchSeq === 1 ||
                                playInfo.titleYn === "Y" ? (
                                    <ClipTitle
                                        playInfo={playInfo}
                                        useLang={props.useLang}
                                        cookie={props.cookie}
                                    />
                                ) : null}
                            </tbody>
                        </table>
                        <table 
                            id="clipDetailTable"
                            style={{ width: "100%" }} 
                            // style={playInfo.pitchTime - props.videoInfos.taggingGapTime < 0 ? { color:"lightgray", width: "100%" } : { width: "100%" }}
                        >
                            <tbody>
                                <tr
                                    style={{
                                        textAlign: "center",
                                        fontSize: "13px",
                                    }}
                                >
                                    <td
                                        style={{ width: "15%", padding: "8px" }}
                                    >
                                        {playInfo.batPitchSeq}(
                                        {playInfo.pureBatPitchSeq})
                                    </td>
                                    <td
                                        style={{ width: "15%", padding: "8px" }}
                                    >
                                        {playInfo.beforeBallCount}-
                                        {playInfo.beforeStrikeCount}
                                    </td>
                                    <td
                                        style={{ width: "20%", padding: "8px" }}
                                    >
                                        {props.useLang === "en"
                                            ? playInfo.ballTypeShortName
                                            : playInfo.ballCodeName}
                                    </td>
                                    <td
                                        style={{ width: "20%", padding: "8px" }}
                                    >
                                        {playInfo.ballSpeed}Km/h
                                    </td>
                                    <td
                                        style={{ width: "15%", padding: "8px" }}
                                    >
                                        {props.useLang === "en"
                                            ? playInfo.hitResultShortName
                                            : playInfo.hitResultName}
                                    </td>
                                    {/* (만약 checkBase 값이 있을 경우, 즉 견제를 했을 경우) */}
                                    <td
                                        style={{ width: "15%", padding: "8px" }}
                                    >
                                        {playInfo.checkBase === "1"
                                            ? props.cookie.getLanguage(
                                                  props.useLang,
                                                  "pick1st"
                                              )
                                            : null}
                                        {playInfo.checkBase === "2"
                                            ? props.cookie.getLanguage(
                                                  props.useLang,
                                                  "pick2nd"
                                              )
                                            : null}
                                        {playInfo.checkBase === "3"
                                            ? props.cookie.getLanguage(
                                                  props.useLang,
                                                  "pick3rd"
                                              )
                                            : null}
                                        {playInfo.checkBase === "23"
                                            ? props.cookie.getLanguage(
                                                  props.useLang,
                                                  "catcherPick1st"
                                              )
                                            : null}
                                        {playInfo.checkBase === "24"
                                            ? props.cookie.getLanguage(
                                                  props.useLang,
                                                  "catcherPick2nd"
                                              )
                                            : null}
                                        {playInfo.checkBase === "25"
                                            ? props.cookie.getLanguage(
                                                  props.useLang,
                                                  "catcherPick3rd"
                                              )
                                            : null}
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                ))}
            </React.Fragment>
        );
    } else {
        return null;
    }
}
